import styled from '@emotion/styled';
import { animated } from 'react-spring';

export const OverlayTransition = styled(animated.div)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 103;
`;
